import dayjs, { Dayjs } from 'dayjs';

const DATE_FORMAT = 'D.M.YYYY';
const DATE_FORMAT_WITH_HOURS = 'D.M.YYYY HH:mm';
const DATE_FORMAT_HOURS = 'HH:mm';

export const toCzDateString = (date: Dayjs | string | Date): string => {
	if (typeof date === 'string') {
		return dayjs(date).format(DATE_FORMAT);
	}

	if (date instanceof Date) {
		return dayjs(date).format(DATE_FORMAT);
	}

	return date.format(DATE_FORMAT);
};

export const toCzDateStringWithHours = (date: Dayjs | string | Date): string => {
	if (typeof date === 'string') {
		return dayjs(date).format(DATE_FORMAT_WITH_HOURS);
	}

	if (date instanceof Date) {
		return dayjs(date).format(DATE_FORMAT_WITH_HOURS);
	}

	return date.format(DATE_FORMAT_WITH_HOURS);
};

export const toCZHoursString = (date: Dayjs | string | Date): string => {
	if (typeof date === 'string') {
		return dayjs(date).format(DATE_FORMAT_HOURS);
	}

	if (date instanceof Date) {
		return dayjs(date).format(DATE_FORMAT_HOURS);
	}

	return date.format(DATE_FORMAT_HOURS);
};

export const czDateStringToDate = (date: string): Dayjs => {
	const parts = date.split('.');
	return dayjs(new Date(`${parts[2]}/${parts[1]}/${parts[0]}`));
};
